import { createSlice } from "@reduxjs/toolkit";

const providerRegistrySlice = createSlice({
    name: "providers",
    initialState: {},
    reducers: {
        registerProvider: (state, action) => {
            const provider = action.payload;
            if (provider?.id) {
                state[provider.id] = provider;
            }
        },
        bulkRegisterProviders: (state, action) => {
            action.payload.forEach((provider) => {
                if (provider?.id) {
                    state[provider.id] = provider;
                }
            });
        }
    }
});

export const { registerProvider, bulkRegisterProviders } = providerRegistrySlice.actions;
export default providerRegistrySlice.reducer;